<template>
  <div class="return-list">
    <ReturnAside @selectProjectFnc="selectProjectFnc"></ReturnAside>
    <div class="return-list-right">
      <div class="search">
        <el-form
          :model="exportForm"
          ref="exportForm"
          class="demo-ruleForm"
        >
          <div class="form-row">
            <el-form-item prop="date" label="时间：">
              <el-date-picker
                v-model="exportForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item  prop="waybillNo" label="运单号：">
              <el-input
                v-model="exportForm.waybillNo"
                placeholder="请填写运单号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="status" label="状态：">
              <el-select
                v-model="exportForm.status"
                placeholder="请选择状态"
              >
                <el-option
                  v-for="item in RETURN_LIST_STATUS_LIST"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item prop="checked" class="check">
              <el-checkbox v-model="exportForm.checked"
                >展示作废记录</el-checkbox
              >
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
              <el-button icon="el-icon-refresh" class="btn-gray" @click="cancelExportForm">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div class="title-container">
        <p class="table-title">退货数据信息</p>
        <div class="upload-return" @click="exportLoginForm('exportForm')">
          <span class="upload-return-img"></span>
          <span>导出</span>
        </div>
      </div>

      <div class="table">
        <el-table 
          :data="tableData" 
          style="width: 100%" 
          :row-class-name="tableRowClassName"
          :header-cell-class-name="headerCellClassName"
        >
          <el-table-column
            v-for="(item, index) in tableTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="goodsInfo"
            label="商品信息"
            min-width="180"
          >
            <template slot-scope="scope">
              <el-tooltip effect="dark" placement="top">
                <div v-html="scope.row.goodsInfoStr" slot="content"></div>
                <div class="oneLine">{{scope.row.goodsInfo}}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="nums"
            label="数量"
          >
          </el-table-column>
          <el-table-column
            prop="unitPrice"
            min-width="150"
            class-name="cell-right-align-width"
            :key="Date.now()"
          >
            <template slot="header" >
              <div>
                单价
                <el-tooltip effect="dark" placement="top" ref="returnObj">
                  <div slot="content">
                    超件单价价格：{{refundPriceRules.unitPrice!=''?refundPriceRules.unitPrice:''}}<br/>
                    退货件数范围：{{refundPriceRules.quantityLimit!=''?refundPriceRules.quantityLimit:'无'}}<br/>
                    超件退货价格：{{refundPriceRules.excessUnitPrice!=''?refundPriceRules.excessUnitPrice:''}}<br/>
                  </div>
                  <img class="question-mark" src="../../../../assets/images/help/help-hign.png">
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            min-width="150"
            prop="amount"
            label="金额"
            class-name="cell-right-align-width"
          >
          </el-table-column>
          <el-table-column
            prop="statusVal"
            label="状态"
          >
            <template slot-scope="scope">
              <div :class="`status${scope.row.statusCopy}`">
                {{scope.row.statusVal}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="120">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status !== 1" class="btn-text" type="text" @click="nullify(scope.row.id)"
                >作废</el-button
              >
              <el-button v-else class="btn-text nullify" type="text" disabled
                >作废</el-button
              >
              <el-button v-if="exportForm.serviceContent == 2 && scope.row.statusCopy < 3 && scope.row.statusCopy" class="btn-text" type="text" @click="finish(scope.row.id)"
                >入库完成</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChargeRegister from "models/charge-register";
import PaginationTpl from "components/base/PaginationTpl";
import statusMixins from '@/common/mixins/status.js'
import ReturnAside from '@/components/layout/return-aside.vue'
import { numsToRMBSymbolAndMillimeter, downLoadFileByBlob } from "common/js/util";
export default {
  mixins: [statusMixins],
  components: {
    PaginationTpl,
    ReturnAside
  },
  data() {
    return {
      warehouseId: null,
      customerId: null,
      projectId: null,
      exportForm: {
        date: "",
        expressCode: '',
        waybillNo: '',
        status: '',
        // 1: 大宗出库; 2:退货服务; 3: 卸货服务; 4:增值服务
        serviceContent: 2,
        checked: false,
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        {label: '日期', prop: 'creatTime', width: '100'},
        {label: '运单号', prop: 'expressCode', width: '120'},
        {label: '原单号', prop: 'originalOrderNo', width: '120'},
        {label: '寄件人', prop: 'sender', width: '120'},
      ],
      returnObj: {
        returnStr: ''
      },
      // projectsNameInfo: []
      refundPriceRules: {
        unitPrice: '',
        quantityLimit: '',
        excessUnitPrice: ''
      }
    }
  },

  created() {
  },

  methods: {
    /** 
     * @desc 退货服务登记记录列表
    */
    initRefundList() {
      let projectId	 = this.projectId
      let customerId	 = this.customerId
      let warehouseId	 = this.warehouseId
      let beginDate	 = this.exportForm.date[0]
      let endDate	 = this.exportForm.date[1]
      let isCancel	 = this.exportForm.checked?1:0
      let currentPage	 = this.currentPage
      let waybillNo = this.exportForm.waybillNo
      let status = this.exportForm.status
      let data = {
        warehouseId,
        beginDate,
        endDate,
        customerId,
        projectId,
        isCancel,
        currentPage,
        expressCode: waybillNo,
        status
      }
      ChargeRegister.getChargeRecordRefundList(data).then((res) => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.warehouseName = value.warehouseName;
            obj.creatTime = value.billDate;
            obj.customersName = value.customerName;
            obj.projectName = value.projectName;
            obj.status = value.isCancel;
            obj.nums = value.checkNum;
            obj.unitPrice = numsToRMBSymbolAndMillimeter(value.unitPrice);
            obj.amount = numsToRMBSymbolAndMillimeter(value.checkPrice);
            obj.expressCode = value.expressCode;
            obj.originalOrderNo = value.originalNo;
            obj.sender = value.sender;
            obj.goodsName = value.goodsName;
            obj.statusCopy = value.status;
            obj.statusVal = this.RETURN_LIST_STATUS[value.status];
            obj.validDate = value.validDate;
            let str = ''
            let str2 = ''
            value.goodsList.map(i => {
              str += `${i.goodsName}，商品${i.quantity}件， <span style="color: red;">次品${i.badQuantity}件</span>，${i.goodsBarCode}，${i.validDate}；`+`<br />`
              str2 += `${i.goodsName}，商品${i.quantity}件， 次品${i.badQuantity}件，${i.goodsBarCode}，${i.validDate}；`
            })
            obj.goodsInfoStr = str
            obj.goodsInfo = str2
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    
    /** 
     * @desc 获取项目名称
    */
    initProjectNameList(customerId, warehouseId) {
      ChargeRegister.getProjectList(warehouseId).then(res => {
        if (res.success) {
          let obj = res.result.find(item => { return item.customerId == customerId})
          let unitPrice = obj.refundPriceRules.unitPrice
          let quantityLimit = obj.refundPriceRules.quantityLimit
          let excessUnitPrice = obj.refundPriceRules.excessUnitPrice
          this.$set(this.refundPriceRules, 'unitPrice', unitPrice)
          this.$set(this.refundPriceRules, 'quantityLimit', quantityLimit)
          this.$set(this.refundPriceRules, 'excessUnitPrice', excessUnitPrice)
        }
      })
    },

    /** 
     * @desc 选择项目
    */
    selectProjectFnc(v) {
      this.warehouseId = v.warehouseId
      this.customerId = v.customerId
      this.projectId = v.projectId
      this.initProjectNameList(v.customerId, this.warehouseId)
      this.initRefundList()
    },
    
    searchData() {
      this.currentPage = 1;
      this.initRefundList();
    },
    
    cancelExportForm() {
      this.exportForm.date = ""
      this.exportForm.expressCode = ""
      this.exportForm.waybillNo = ""
      this.exportForm.status = ""
      this.exportForm.checked = false
    },
    
    /**
     * @desc 导出
     */
    exportLoginForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let projectId	= this.projectId
          let customerId = this.customerId
          let warehouseId	= this.warehouseId
          let beginDate	= this.exportForm.date[0]
          let endDate	= this.exportForm.date[1]
          let isCancel = this.exportForm.checked?1:0
          let currentPage	= this.currentPage
          let waybillNo = this.exportForm.waybillNo
          let status = this.exportForm.status
          let data = {
            warehouseId,
            beginDate,
            endDate,
            customerId,
            projectId,
            isCancel,
            currentPage,
            status,
            expressCode: waybillNo
          }
          ChargeRegister.getExport(data, this.exportForm.serviceContent).then((res) => {
            downLoadFileByBlob(res)
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initRefundList();
    },

    /** 
     * @desc 为 Table 中的某一行添加 class
    */
    tableRowClassName({row}) {
      if (row.status !== 1) {
        return '';
      }
      return 'active';
    },

    nullify(id) {
      this.$confirm("作废后，该退货单将不可再次操作，请确认", "作废", {
        confirmButtonText: "作废",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          id
        }
        ChargeRegister.postNullify(data, this.exportForm.serviceContent).then(res => {
          if (res.success) {
            this.initRefundList();
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
      });
    },
    
    finish(id) {
      this.$confirm("完成后，该退货单将结束流程，请确认", "入库完成", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        ChargeRegister.postFinish(id).then(res => {
          if (res.success) {
            this.initRefundList();
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
      });
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex > 5 && columnIndex < 8) {
        return 'right-align'
      }
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/production/return-list.scss';
</style>
